import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import SettingsSidebar from "./components/SettingsSidebar";
import "./SettingsLayout.css";

const SettingsPage: React.FC = () => {
  const location = useLocation();

  const isFeaturePreview = location.pathname.includes("/feature-preview");

  return (
    <div className="settings-container">
      <div className="settings-layout">
        {!isFeaturePreview && <SettingsSidebar />}

        <div className="settings-main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
